import { initDefaultGbpe } from '../../configs/gbpe/default'
import { UnitedStatesConfig } from '../../configs/united-states'
import { Brand } from '../../../../types/brand'
import navStyles from '@scss/global-nav/global-nav.crossbrand.scss'

import { generateNav } from '../../nav-generator'

generateNav(
	navStyles.toString(),
	'crossbrand-experience-gm-us-en-main',
	'https://brands.gm-cdn.com/_gbpe/code/prod1/images/fallback-thumb.png',
	'crossbrand-experience-gm-us-en-main',
	new UnitedStatesConfig(Brand.crossbrand),
	initDefaultGbpe
)

// Export to prevent tree shaking
export const crossbrand_us_enNav = true
